import {MasterOfActsAPI} from "../api/api.js";

export const listToTree = (list) => {
    let map = {}, node, roots = [], i

    for (i = 0; i < list.length; i += 1) {
        map[list[i].id] = i
        list[i].children = []
    }

    for (i = 0; i < list.length; i += 1) {
        node = list[i]
        if (node.parent_id !== "0") {
            list[map[node.parent_id]].children.push(node)
        } else {
            roots.push(node)
        }
    }
    return roots
}


export const createNormativeDocumentsFromJson = async (documents) => {
    for (const document of documents) {
        const createdDocument = await createNormativeDocument(document.name)

        if (document.children !== 0) {
            for (const chapter of document.children) {
                await createDocumentTree(chapter, createdDocument.data.id, null)
            }
        }

        if (document.items !==0) {
            const chapter = await createNormativeChapter(document.name, createdDocument.data.id, null)
            for (const item of document.items) {
                await createNormativeArticles(null, item.short_name, item.full_name, createdDocument.data.id, chapter.data.id)
            }
        }
    }
}

const createNormativeDocument = async name => await MasterOfActsAPI.createNormativeDocument(name)

const createNormativeChapter = async (name, normativeDocument, normativeChapter) => {
    return await MasterOfActsAPI.createNormativeChapter(name, normativeDocument, normativeChapter)
}

const createNormativeArticles = async (number, shortText, fullText, normativeDocument, normativeChapter) => {
    return await MasterOfActsAPI.createNormativeArticles(number, shortText, fullText, normativeDocument, normativeChapter)
}

const createDocumentTree = async (node, normativeDocument, normativeChapter) => {
    const chapter = await createNormativeChapter(node.name, normativeDocument, normativeChapter)
    if (node.children && node.children.length !== 0) {
        for (const child of node.children) {
            await createDocumentTree(child, normativeDocument, chapter.data.id)
        }
    }
    if (node.items && node.items.length !== 0) {
        for (const item of node.items) {
            await createNormativeArticles(null, item.short_name, item.full_name, normativeDocument, chapter.data.id)
        }
    }
}